module.exports = __webpack_public_path__ + "img/243.4908f89f.jpg";